import Check from '../Check';
import Report from '../Report';
import { MessageType } from '../Message';

class InheritanceLoopCheck extends Check {
  static description = 'Check for inheritance loops';

  check(): Report {
    this.report = new Report();
    let success = true;

    for (const object of this.model.objectTypes) {
      let inheritances = object.inheritancesAsSubtype;
      while (inheritances.length > 0) {
        if (inheritances.length > 1) {
          this.report.addMessage(
            MessageType.ERROR,
            `Object ${object.asString()} has more than one supertype.`,
            this,
            object
          );
          success = false;
          break;
        } else if (inheritances[0].supertype === object) {
          this.report.addMessage(
            MessageType.ERROR,
            `Object ${object.asString()} cannot inherit from itself.`,
            this,
            object
          );
          success = false;
          break;
        } else {
          inheritances = inheritances[0].supertype.inheritancesAsSubtype;
        }
      }
    }
    if (success) {
      this.report.addMessage(
        MessageType.INFORMATION,
        'All inherited objects have a valid supertype.',
        this,
        this.element
      );
    }
    return this.report;
  }
}

export default InheritanceLoopCheck;
